import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServiceCard = ({ service, index }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
            viewport={{ once: true, margin: "-50px" }}
        >
            <div className="service-card-photo hover-lift">
                {/* Service Category Badge */}
                <div className="service-category-badge">
                    <i className={`fas ${service.icon} me-2`}></i>
                    <span>Service</span>
                </div>

                {/* Image Container */}
                <div className="service-photo-container">
                    <img
                        src={service.image}
                        alt={service.title}
                        className="service-photo"
                        loading="lazy"
                    />
                    <div className="service-photo-overlay"></div>
                </div>

                {/* Card Body */}
                <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>

                    {/* Service Features */}
                    <div className="service-features">
                        {service.features && service.features.map((feature, idx) => (
                            <div key={idx} className="d-flex align-items-center mb-2">
                                <i className="fas fa-check-circle text-primary-red me-2"></i>
                                <span>{feature}</span>
                            </div>
                        ))}
                    </div>

                    {/* Book Now Button */}
                    <Link
                        to="/contact"
                        state={{ selectedService: service.title }}
                        className="btn-primary-custom text-decoration-none mt-3 align-self-start"
                    >
                        Book Now
                        <i className="fas fa-calendar-check ms-2"></i>
                    </Link>
                </div>
            </div>
        </motion.div>
    );
};

export default ServiceCard;